import React, { useState } from 'react';
import { storeGetOrDefault, storeSet, DEF_FOOTER } from '../../store';
import '../admin.css';

const Toast = ({ msg, type }) => msg ? <div className={`adm-toast adm-toast-${type}`}>{msg}</div> : null;

const FooterAdmin = () => {
  const [cfg, setCfg] = useState(() => storeGetOrDefault('footer', DEF_FOOTER));
  const [toast, setToast] = useState({ msg: '', type: 'success' });

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast({ msg: '', type: 'success' }), 3000);
  };

  const f = (k) => (e) => setCfg(c => ({ ...c, [k]: e.target.value }));
  const fb = (k) => (e) => setCfg(c => ({ ...c, [k]: e.target.checked }));

  const handleSave = (e) => {
    e.preventDefault();
    storeSet('footer', cfg);
    showToast('Footer settings saved!');
  };

  return (
    <div className='adm-page'>
      <Toast {...toast} />

      <div className='adm-page-hero'>
        <div className='adm-page-hero-icon' style={{ background: 'linear-gradient(135deg,#d4720e,#f59e0b)' }}>
          <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#fff' strokeWidth='2'>
            <rect x='3' y='3' width='18' height='18' rx='2'/><line x1='3' y1='9' x2='21' y2='9'/><line x1='3' y1='15' x2='21' y2='15'/><line x1='9' y1='9' x2='9' y2='21'/><line x1='15' y1='9' x2='15' y2='21'/>
          </svg>
        </div>
        <div>
          <h1 className='adm-title'>Footer</h1>
          <p className='adm-subtitle'>Manage footer description, copyright text and external links shown at the bottom of every page</p>
        </div>
      </div>

      <form onSubmit={handleSave}>
        <div className='adm-settings-grid'>

          {/* Company Description */}
          <div className='adm-settings-card'>
            <h3 className='adm-settings-card-title'>📝 Company Description</h3>
            <div className='adm-form' style={{ gap: 14 }}>
              <div className='adm-form-group'>
                <label className='adm-label'>Footer Tagline / Description</label>
                <textarea
                  className='adm-input adm-textarea'
                  value={cfg.companyDesc || ''}
                  onChange={f('companyDesc')}
                  placeholder='Brief company description shown in footer brand column...'
                  rows={4}
                />
                <p className='adm-hint'>Displayed under the ZINGA logo in the footer.</p>
              </div>
              <div className='adm-form-group'>
                <label className='adm-label'>Copyright Company Name</label>
                <input
                  className='adm-input'
                  value={cfg.copyrightName || ''}
                  onChange={f('copyrightName')}
                  placeholder='John Galt Zinga Technologies'
                />
                <p className='adm-hint'>Used in the "© 2026 [name]. All rights reserved." line.</p>
              </div>
            </div>
          </div>

          {/* External Links */}
          <div className='adm-settings-card'>
            <h3 className='adm-settings-card-title'>🔗 External Links (Footer Bottom Bar)</h3>
            <div className='adm-form' style={{ gap: 14 }}>
              <div className='adm-form-row'>
                <div className='adm-form-group'>
                  <label className='adm-label'>Link 1 Label</label>
                  <input className='adm-input' value={cfg.extLink1Label || ''} onChange={f('extLink1Label')} placeholder='John Galt International' />
                </div>
                <div className='adm-form-group'>
                  <label className='adm-label'>Link 1 URL</label>
                  <input className='adm-input' value={cfg.extLink1Url || ''} onChange={f('extLink1Url')} placeholder='https://www.johngalt.in' />
                </div>
              </div>
              <div className='adm-form-row'>
                <div className='adm-form-group'>
                  <label className='adm-label'>Link 2 Label</label>
                  <input className='adm-input' value={cfg.extLink2Label || ''} onChange={f('extLink2Label')} placeholder='ZingaMetall BvBa' />
                </div>
                <div className='adm-form-group'>
                  <label className='adm-label'>Link 2 URL</label>
                  <input className='adm-input' value={cfg.extLink2Url || ''} onChange={f('extLink2Url')} placeholder='https://www.zinga.be' />
                </div>
              </div>
            </div>
          </div>

          {/* Visibility */}
          <div className='adm-settings-card'>
            <h3 className='adm-settings-card-title'>👁 Section Visibility</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {[
                ['showQuickLinks', 'Show "Quick Links" column'],
                ['showProducts',   'Show "Products" column'],
              ].map(([k, label]) => (
                <label key={k} style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer', padding: '12px 16px', background: '#f8faff', borderRadius: 10, border: '1px solid #e5e9f4' }}>
                  <input
                    type='checkbox'
                    checked={cfg[k] !== false}
                    onChange={fb(k)}
                    style={{ width: 18, height: 18, accentColor: '#1a5fa3', cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '.9rem', fontWeight: 600, color: '#374151' }}>{label}</span>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
          <button type='submit' className='adm-btn adm-btn-primary' style={{ padding: '12px 36px', fontSize: '1rem' }}>
            Save Footer Settings
          </button>
        </div>
      </form>
    </div>
  );
};

export default FooterAdmin;
